function showToast(message, duration = 3000) {
    let toast = document.querySelector('.toast');
    if (!toast) {
        toast = document.createElement('div');
        toast.className = 'toast';
        document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('visible');
    setTimeout(() => {
        toast.classList.remove('visible');
    }, duration);
}

function copyToClipboard(text) {
    if(!navigator.clipboard) {
        fallbackCopyToClipboard(text);
    }
    navigator.clipboard.writeText(text)
        .then(() => showToast('Link copied to clipboard!'))
        .catch(err => {
            console.error('Failed to copy:', err);
            fallbackCopyToClipboard(text);
        });
}

function fallbackCopyToClipboard(text) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';  // Avoid scrolling to bottom
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
        const successful = document.execCommand('copy');
        showToast(successful ? 'Link copied to clipboard!' : 'Unable to copy link');
    } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
        showToast('Unable to copy link');
    }    
    document.body.removeChild(textArea);
}

export function initShareButton(buttonElement) {

    buttonElement.addEventListener('click', async () => {
        const url = window.location.href;
        const title = document.title;
        const text = "Check out this cryptocurrency market cap race!";
        if (!navigator.share) {
            copyToClipboard(url);
            return;
        }    
        try {
            await navigator.share({
                title: title,
                text: text,
                url: url
            });
            showToast('Shared successfully!');
        } catch (err) {
            if (err.name !== 'AbortError') {
                showToast('Error sharing. Link copied to clipboard instead.');
                copyToClipboard(url);
            }
        }

    });

}
